export class VendorTitle {
  static format(vendor) {
    return (
      (vendor.code || "") +
      (vendor.code && vendor.name ? " | " : "") +
      (vendor.name || "")
    );
  }
}
